import { observer } from 'mobx-react-lite';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { editorStore } from '../../stores/EditorStore';
import { gameStore } from '../../stores/GameStore';
import { mainMapEditorStore } from '../../stores/MapEditorStore';
import { sharedStore } from '../../stores/SharedStore';
import { undoableMapEditorLoadMap } from '../../stores/undo/operation/MapEditorLoadMapOp';
import { MapSelector } from '../mapEditor/MapSelector';
import { MenuCard } from '../menu/MenuCard';
import { MenuCardLabel } from '../menu/MenuCardLabel';
import { LoadingBarBlock } from '../shared/LoadingBar';
import { GameContainer } from './GameContainer';
import { PlayerCharacterEditor } from "./PlayerCharacterEditor";
const FullscreenContainer = styled.div.withConfig({
  displayName: "EditorGame__FullscreenContainer",
  componentId: "sc-ut197v-0"
})(["position:fixed;left:0;right:0;top:0;bottom:0;background-color:black;"]);
const TopLeft = styled.div.withConfig({
  displayName: "EditorGame__TopLeft",
  componentId: "sc-ut197v-1"
})(["position:fixed;left:2em;top:4em;"]);

function getErrorText(t) {
  if (!sharedStore.mayOpenGame) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(LoadingBarBlock, {
      label: t("editor.loading_tile_images"),
      percentage100: editorStore.tileImageLoadingPercentageInt100
    }), /*#__PURE__*/React.createElement(LoadingBarBlock, {
      label: t("editor.loading_sounds"),
      percentage100: Math.floor(sharedStore.gameSoundsLoadingPercentage * 100)
    }));
  }

  if (!gameStore.hasStartMap) {
    const {
      currentMapId,
      runningMapOperation
    } = mainMapEditorStore.currentMapStore;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(MenuCard, null, /*#__PURE__*/React.createElement(MenuCardLabel, null, t("editor.map")), /*#__PURE__*/React.createElement(MapSelector, {
      selectedMapId: currentMapId,
      onSelected: mapId => undoableMapEditorLoadMap(mainMapEditorStore.currentMapStore, mapId),
      disabled: runningMapOperation,
      width100percent: true
    })));
  }

  return null;
}

export const EditorGame = observer(() => {
  const {
    t
  } = useTranslation();
  const errorText = getErrorText(t);
  const showCharacterEditor = !gameStore.character && !errorText;
  const showGame = !showCharacterEditor && !errorText;
  return /*#__PURE__*/React.createElement(FullscreenContainer, null, showGame && /*#__PURE__*/React.createElement(GameContainer, null), showCharacterEditor && /*#__PURE__*/React.createElement(PlayerCharacterEditor, null), errorText && /*#__PURE__*/React.createElement(TopLeft, null, errorText));
});